import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../../constants/languages";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import moment from "moment-timezone";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";

export default class EditDiaDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.dia
            ? languages.present.editDia
            : languages.present.addDia}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText />
            <TextField
              fullWidth
              name="title"
              value={this.props.title}
              onChange={this.props.handleTitleChange}
              label={languages.present.title}
            />
            <FormControl
              aria-describedby="weight-helper-text"
              style={{ width: "100%", marginTop: 15 }}
            >
              <InputLabel htmlFor="break-duration">
                {languages.present.duration}
              </InputLabel>
              <Input
                id="dia-duration"
                type="number"
                name="duration"
                placeholder="10"
                value={this.props.time}
                onChange={this.props.handleChange}
                endAdornment={
                  <InputAdornment position="end">
                    {languages.present.seconds}
                  </InputAdornment>
                }
              />
            </FormControl>
            {(this.props.days || []).length > 0 && (
              <FormControl style={{ marginTop: 15 }}>
                <InputLabel htmlFor="day">{languages.schedule.day}</InputLabel>
                <Select
                  style={{ width: 300 }}
                  value={
                    this.props.day === "all" ||
                    this.props.day === "0" ||
                    this.props.daysByKey[this.props.day]
                      ? this.props.day
                      : "all"
                  }
                  onChange={this.props.handleSelectDay}
                  inputProps={{
                    name: "day",
                    id: "day",
                  }}
                >
                  <MenuItem value="all">
                    <em>{languages.present.allDays}</em>
                  </MenuItem>
                  <MenuItem value="0">
                    {moment
                      .unix(this.props.tournament.date)
                      .tz(this.props.tournament.timezone || "Europe/Amsterdam")
                      .format(languages.createTournament.dateFormat)}
                  </MenuItem>
                  {this.props.days.map((day) => (
                    <MenuItem key={day.id} value={day.id}>
                      {moment
                        .unix(day.date)
                        .tz(
                          this.props.tournament.timezone || "Europe/Amsterdam"
                        )
                        .format(languages.createTournament.dateFormat)}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {languages.present.selectDayDescription}
                </FormHelperText>
              </FormControl>
            )}
          </DialogContent>
          <DialogActions>
            {this.props.dia && (
              <Button onClick={this.props.handleDelete} color="secondary">
                {languages.general.delete}
              </Button>
            )}
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <Button
              onClick={this.props.handleSubmit}
              variant="contained"
              color="primary"
              type="submit"
            >
              {this.props.dia ? languages.general.save : languages.general.add}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
